var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBookingInfoIcon = function SvgBookingInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.667V8.001m0-2.667h.007m6.66 2.667A6.667 6.667 0 1 1 1.333 8a6.667 6.667 0 0 1 13.334 0Z",
    stroke: "#667085",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgBookingInfoIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNOC4wMDAwMSAxMC42NjczVjguMDAwNjVNOC4wMDAwMSA1LjMzMzk4SDguMDA2NjhNMTQuNjY2NyA4LjAwMDY1QzE0LjY2NjcgMTEuNjgyNiAxMS42ODE5IDE0LjY2NzMgOC4wMDAwMSAxNC42NjczQzQuMzE4MTEgMTQuNjY3MyAxLjMzMzM0IDExLjY4MjYgMS4zMzMzNCA4LjAwMDY1QzEuMzMzMzQgNC4zMTg3NSA0LjMxODExIDEuMzMzOTggOC4wMDAwMSAxLjMzMzk4QzExLjY4MTkgMS4zMzM5OCAxNC42NjY3IDQuMzE4NzUgMTQuNjY2NyA4LjAwMDY1WiIgc3Ryb2tlPSIjNjY3MDg1IiBzdHJva2Utd2lkdGg9IjEuNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";